import React from 'react';
import ReactTooltip from 'react-tooltip';
import { map } from 'lodash';
import AbsoluteValue from '../../../common/AbsoluteValue';
import CountryFlag from '../../../common/CountryFlag';
import { percentageValue } from '../../../../helpers/NumberFormatter';
import Tooltip from '../../../common/Tooltip';

export const territorySettings = {
    settingsForTable
};


function settingsForTable(mode){

    
    let columns = [
       {
           id: 'rank',
           className: 'rank',
           headerClassName: ' rank',
           Header: 'Rank',
           width: 80,
           accessor: 'rank'
       },
                   
        {
            id: 'logo',
            className: 'logo-sell',
            headerClassName: 'logo-sell no-sort',
            Header: '',
            accessor: 'name',
            width: 40,
            sortable: false,
            Cell: props => {
                return <CountryFlag className="flag-medium" country={props.original.code} />
         }
      },
      {
          id: 'name',
       //    className: 'imprint-name',
       //    headerClassName: 'imprint-name',
          Header: 'Country',
          accessor: 'name',
       //    width: 190
      },      
      {
              id: 'share',
              headerClassName: '',
              Header: 'Share',
              // width: 70,
              accessor: 'share',
              Cell: props => <span>{props.value}%</span>,
          },
       {
           id: 'total',
           headerClassName: ' total',
           className: 'total',
           Header: 'Total',
           Cell: props => <AbsoluteValue value={props.value}></AbsoluteValue>,
           // width: 70,
           accessor: 'curr_units'
       },       
       {
           id: 'skipped_ratio',
           headerClassName: '',
           Header: props => <div className="top-table-header-inner">
               Skip Rate
               <div className="table-header-tooltip">
                    <Tooltip position="bottom" message={`The Skip rate only applies to streams over 30 seconds. It's a metric provided by all DSPs except YouTube and Google.`} tooltipClass="toolbar-title-tooltip"/>
                </div>
            </div>,

           Cell: props => <span>{props.value}%</span>,
           // width: 110,
           accessor: 'skipped_ratio'
       },       
       {
           id: 'completed_ratio',
           headerClassName: '',
           Header: props => <div className="top-table-header-inner">
               Completion Rate
               <div className="table-header-tooltip">
                    <Tooltip position="right-bottom" message={`A track is marked as complete when the stream reached 95% of the track length. It's a metric provided by all DSPs except YouTube and Google.`} tooltipClass="toolbar-title-tooltip"/>
                </div>
            </div>,

           Cell: props => <span>{props.value}%</span>,
           width: 120,
           accessor: 'completed_ratio'
       },
       /*
       {
           id: 'curr_listeners',
           headerClassName: '',
           className: 'listeners',
           Header: 'Listeners',
           Cell: props => <AbsoluteValue value={props.value}></AbsoluteValue>,
           // width: 100,
           accessor: 'curr_listeners'
       },
       */       

    ];
    return columns;
}